export enum ToastType {
  DEFAULT = "default",
  ERROR = "error",
}
